import homeSection from "@/assets/tax/heroDesktop.png"
import homeSectionMobile from "@/assets/tax/heroDesktop.png"
import homeSectionTablet from "@/assets/tax/hero.png"
import wa from "@/assets/wa-outline.svg"

export const homeTax = {
  "section" : "home",
  "imageDesktop" : homeSection,
  "imageMobile" : homeSectionMobile,
  "imageTablet" : homeSectionTablet,
  "text" : {
      "tiny_title": "tax_home_tiny_title",
      "main_title": "tax_home_main_title",
      "description": "tax_home_description",
      "button": {
          "first": "tax_home_button_first",
          "second": null,
          "image": wa,
          "link_second" : 'tax_home_link_wa'
      },
      "in_pict": {
        "first_card" : {
          "main_title" : "tax_home_first_card_title_1",
          "second_title" : "tax_home_first_card_title_2",
          "third_title" : "tax_home_first_card_title_3",
          "second_description": "Pph 21",
          "third_description" : "Rp 900,000"
        },
        "second_card" : {
            "main_title" : "tax_home_second_card_title_1",
            "second_title" : "tax_home_second_card_title_2",
            "third_title" : "tax_home_second_card_title_3",
            "second_description": "PPh 4(2)",
            "third_description" : "Rp 1,900,000"
        }
      }
  }
}